import React from "react"
// @ts-ignore
import styled from 'styled-components';
import Images from "../../../../assets/images/Images";

interface Props {
    customStyle?: object,
}

const StyledImage = styled.img `
    display: inline-block;
    margin: 0.5em;
    filter: brightness(0) invert(1);
    height: 18px;
`;

const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const SocialMediaHeader: React.FC<Props> = ({customStyle}) => {
    return (
        <StyledContainer style={{...customStyle}}>
            <a href="https://www.facebook.com/MAPFRE.ES/" target="_blank" rel="noopener noreferrer">
                <StyledImage src={Images.fb} alt="Facebook"/>
            </a>
            <a href="https://www.instagram.com/mapfre/" target="_blank" rel="noopener noreferrer">
                <StyledImage src={Images.ig} alt="Instagram" />
            </a>
            <a href="https://twitter.com/mapfre/" target="_blank" rel="noopener noreferrer">
                <StyledImage src={Images.linkedin} alt="Linkedin" />
            </a>
            <a href="https://twitter.com/mapfre/" target="_blank" rel="noopener noreferrer">
                <StyledImage src={Images.wsp} alt="Whatsapp" />
            </a>
            <a href="https://twitter.com/mapfre/" target="_blank" rel="noopener noreferrer">
                <StyledImage src={Images.yt} alt="Youtube" />
            </a>
        </StyledContainer>
    )
};

export default SocialMediaHeader;
